import React from "react"
import {BVAInputContainer} from "./styled";
import {TextField} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { NumericFormat } from 'react-number-format';


const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref,
) {
  const { decimalScale, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.formattedValue,
          },
        });
      }}
      thousandSeparator
      decimalScale={decimalScale}
      valueIsNumericString
    />
  );
});

export default function BVAInput({
  sx,
  width,
  value,
  disabled,
  type,
  size,
  variant,
  textAlign,
  endAdornment,
  startAdornment,
  endAdornmentLabel,
  decimalScale = 2,
  startAdornmentLabel,
  onChange = () => ({}),
  onBlur = () => ({})
}) {
  return (
    <BVAInputContainer width={width} textAlign={textAlign}>
      <TextField
        value={value}
        variant={variant ? variant : "outlined"}
        classes={{ root: "bva-input" }}
        disabled={disabled}
        type={type}
        size={size}
        sx={sx}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onBlur(e.target.value)}
        InputProps={{
          inputComponent: type === "text" ? null : NumericFormatCustom,
          inputProps: { decimalScale },
          endAdornment: endAdornment ? (
            <InputAdornment position="end">{endAdornmentLabel}</InputAdornment>
          ) : null,
          startAdornment: startAdornment ? (
            <InputAdornment position="start">{startAdornmentLabel}</InputAdornment>
          ) : null
        }}/>
    </BVAInputContainer>
  )
}